import { IObject } from "../../../../shared/utils/utils";
import { noop } from "../../../utils";
import { IWidgetLayout } from "../widget-component/widget-component";
import WidgetsLayout from "../widgets-layout";

interface IReadonlyWidgetComponentProps {
  layout: IWidgetLayout;
  dataReadonly?: boolean;
  data?: IObject;
  onDataChanged?(newValue: string, key?: string): void
}

const ReadonlyWidgetComponent = ({layout, dataReadonly, data, onDataChanged}: IReadonlyWidgetComponentProps) => {
  return <div className="readonlyWidgetComponent">
    <WidgetsLayout
      layout={layout}
      readonly={true}
      dataReadonly={dataReadonly}
      onLayoutChanged={noop}
      onWidgetEdit={noop}
      data={data}
      onDataChanged={onDataChanged}
    />
  </div>;
};

export default ReadonlyWidgetComponent;